import { ErrorMsg } from '@/jupiter/features/forget-password';
import { z } from 'zod';

export const forgetPasswordSchema = (errorMsg: ErrorMsg) => z.object({
	email: z.string().min(1, errorMsg.emailEmpty).email(errorMsg.emailFormat),
	answer: z.string().min(1, errorMsg.answerEmpty),
	question: z.string({ required_error: errorMsg.questionEmpty }).default('').refine(
		(value) => value !== '', {
			message: errorMsg.questionEmpty
		}
	),
});

export type forgetPasswordInputs = z.infer<ReturnType<typeof forgetPasswordSchema>>;